export default __webpack_public_path__ + "static/media/13.a23b2d7b.svg";